import { Link } from 'react-router-dom';
import { showNumber, showPercent } from '../../libs/util';

const Component = ({ plan }) => {
  const getCurrencyName = (currency) => {
    return currency === 'USD' ? 'US$' : currency;
  };

  return (
    <div className="nk-ivp-card card card-bordered card-full">
      <div className="card-inner-group">
        <div className="card-inner">
          <div className="nk-ivp-title card-title">
            <h6 className="data">{plan.display_title}</h6>
            {plan.source.toUpperCase() === 'USD' ||
            plan.target.toUpperCase() === 'USD' ? (
              <h1 className="icon-stack">
                <em
                  className={
                    'bg-dark-dim icon ni ni-sign-' +
                    plan.target +
                    '-alt icon-stack-back'
                  }
                ></em>
                <em
                  className={
                    'bg-' +
                    plan.source +
                    '-dim icon ni ni-sign-' +
                    plan.source +
                    '-alt icon-stack-front'
                  }
                ></em>
              </h1>
            ) : (
              <h1 className="icon-stack">
                <em
                  className={
                    'bg-' + 'btc' + '-dim icon ni ni-sign-' + 'btc' + '-alt '
                  }
                ></em>
              </h1>
            )}
            <br />
            {/* <span className="data">
              Invest with {getCurrencyName(plan.source.toUpperCase())}
            </span>
            <br />
            <span className="data">
              <i>{plan.tagline}</i>
            </span> */}
          </div>

          <div className="nk-ivp-action">
            <Link
              className="btn btn-primary"
              to={'/portal/planbtc/invest/' + plan.source + '/' + plan.target}
            >
              <span>Invest</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
